import qs from 'qs';
import _indexOf from 'lodash/indexOf';
import _get from 'lodash/get';
import _isNil from 'lodash/isNil';
import _uniqBy from 'lodash/uniqBy';
import _toString from 'lodash/toString';
import dayjs from 'dayjs';
import * as XLSX from 'xlsx';
import { XlsxColumn } from 'routes/constants';

export * from './status';

export function formatTime(data: dayjs.ConfigType, format: string) {
  return !!data ? dayjs(data).format(format) : '';
}

export const exportXlsxFile = (name: string, headers: string[], aoa: string[][]) => {
  var worksheet = XLSX.utils.aoa_to_sheet([headers, ...aoa]);
  var workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'SheetJS');
  XLSX.writeFile(workbook, `${name}.xlsx`, { type: 'binary', bookType: 'xlsx' });
};

export const getUrlParamsBySearch = (search: string) => {
  const parseConfigs = { comma: true };
  const qsStart = _indexOf(search, '?') + 1;
  return qs.parse(search.slice(qsStart), parseConfigs);
};

export function simpleStringCompare(a: unknown, b: unknown) {
  return _toString(a).localeCompare(_toString(b));
}

export const stringifyUrlParams = (params: Record<string, unknown>) =>
  `${qs.stringify(params, {
    arrayFormat: 'comma',
    skipNulls: true,
    encode: false,
    sort: simpleStringCompare,
  })}`;

export function openLinkInNewTab(url: string) {
  return window.open(url, '_blank', 'noopener, noreferrer');
}

export const convertEnumToList = (
  object: Object
): Array<{
  id: string;
  name: string;
  value: string;
}> =>
  Object.keys(object).map((value) => {
    return {
      value,
      id: value,
      name: object[value],
      label: object[value],
    };
  });

export const composeXlsAoa = (data: string[][], columns: Array<XlsxColumn>) => {
  return data.map((row: string[]) =>
    columns.map((col) => {
      const rawColData = _get(row, col.key);
      const colData = _isNil(rawColData) ? '' : rawColData;
      return !!col.transform ? col.transform(colData) : colData;
    })
  );
};

export function deDuplicatedPlatformOrderId<T>(data: any | T): T {
  return _uniqBy(data, 'platform_order_id') as T | any;
}

export function mapLogisticsNumberToTrackingNo<T>(data: any | T) {
  return data.map((d) => ({
    ...d,
    logistics_number: d.tracking_no,
  }));
}

export function addBusinessDays(originalDate: dayjs.Dayjs, numDaysToAdd: number): dayjs.Dayjs {
  const Sunday = 0;
  const Saturday = 6;
  let daysRemaining = numDaysToAdd;
  let newDate = originalDate.clone();
  while (daysRemaining > 0) {
    newDate = newDate.add(1, 'days');
    if (newDate.day() !== Sunday && newDate.day() !== Saturday) {
      daysRemaining--;
    }
  }
  return newDate;
}

export const sessionStorageHelper = (key: string) => ({
  getItem: (defaultValue: Record<string, unknown> | null | undefined = null) => {
    const value = sessionStorage.getItem(key);
    return value ? JSON.parse(value) : defaultValue;
  },
  setItem: (value: Record<string, unknown>) => {
    sessionStorage.setItem(key, JSON.stringify(value));
  },
  removeItem: () => {
    sessionStorage.removeItem(key);
  },
});
